import template from './tableGridAccordionToggleCell.html';
import controller from './tableGridAccordionToggleCell.controller';

let tableGridAccordionToggleCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      metaData: '=',
      options: '=',
      showDrawer: '='
    },
    template,
    controller,
    controllerAs: 'vm'
  };
};

export default tableGridAccordionToggleCellComponent;



// WEBPACK FOOTER //
// ./app/components/tableGridAccordionToggleCell/tableGridAccordionToggleCell.component.js